module.exports = __webpack_public_path__ + "img/2.c5a730f4.jpg";